<template>
  <div>

<!--   顶部提示-->
    <div class="toolTip-bottom" v-if="item.id===clickId"  :style="{
      left :  ((item.width-130) /2 + 'px'),
    }">
      <div class="toolTip-bottom-font" @click="$emit('delete',item.id)"  >删除</div>
      <div class="toolTip-bottom-right"></div>
      <div class="toolTip-bottom-font"  @click="$emit('setting',item)">设置</div>
    </div>
<!--    顶部提示结束-->
    <div class=" coordinates-title" :class="[ !in_array(item.control_library_id, [8,9,10,13,15]) || 'max-center']" :style="getStyle">
      <div class="filler" v-if=" !(item.id===clickId) && item.width > 100" >{{ item.is_require == 1 ? '* ' : '' }}{{ getFillName() }}:{{ getFillContent() }}  </div>



        <div v-if="item.control_library_id===6 || item.control_library_id===7">

        </div>
          <div v-else :style="`transform:scale(${scale});`">
          {{ getDefaultContent }}
          </div>

    </div>

  </div>
</template>

<script>
import modal from "@/components/modal/modal";

export default {
  name: "ControlLibraryContent",
  components: {},
  props: {
    item: {
      type: Object
    },scale: {
      type: Number
    },
    clickId: {
      type: String
    }
  },

  computed : {


    /**
     * 获取样式
     * @returns {string}
     */
    getStyle() {

      let  css = ``;
      let height =  this.item.height - 2
      let width =  this.item.width - 2;
      switch (this.item.control_library_id) {
        case 6:
          width-=8
              height-=8
          css+= `border-radius:50%;`
          css+= `border:4px solid #8d8d8d;`
          css+= `background-color:#f1f1f1;`
          css+= `padding-right: 0;`
              break;
        case 7:
          width-=6
          height-=6
          css+= `border:3px solid #8d8d8d;`
          css+= `background-color:#f1f1f1;`
          css+= `padding-right: 0;`
          break;

      }


      let justify_content = this.item.font_align==='right'?'end':this.item.font_align
      if (this.item.control_library_id=== 8
        || this.item.control_library_id=== 9
          || this.item.control_library_id=== 10
          || this.item.control_library_id=== 13
          || this.item.control_library_id=== 15
      )
       justify_content = 'center'

      let font_size = this.item.font_size===-1 ? 12 : this.item.font_size

      css+= `color:${this.item.color};`
      css+= `height:${height}px;`
      css+= `width:${width}px;`
      css+= `justify-content:${justify_content}px;`
      css+= `font-size:${font_size}px;`



      return css;
    },

    /**
     * 获取合同编号
     * @returns {string}
     */
    getDocNumberDemo() {
      let number = this.item.doc_number_length
      let numberHtml = "";
      for (let i = 0; i <= number - 2; i++) {
        numberHtml += "0";
      }
      return this.item.doc_number_prefix +''   + numberHtml + "1" + this. item.doc_number_suffix;
    },
    /**
     * 获取默认的输出内容
     * @returns {string|*}
     */
    getDefaultContent() {
      switch (this.item.control_library_id) {
        case 3:
          return this.item.date;
        case 14:
          return this.getDocNumberDemo
        default :
          return  this.item.name

      }

    },
  },
  methods: {

    getFillName() {

      if (this.in_array(this.item.control_library_id,[13,15]))
        return "*签署人";
      else if (this.in_array(this.item.control_library_id,[17,18,19]))
        return "*数据来源";
      else
        return  "*填写人"
    },

    getFillContent() {

      if (this.in_array(this.item.control_library_id, [14,16]))
        return "系统"
      else  if (this.in_array(this.item.control_library_id, [17,18,19]))
        return this.item.auto_sign_filler

      return  this.item.filler

    },
    /**
     * 检测是否包含
     * @param need
     * @param array
     * @returns {boolean}
     */
    in_array(need, array) {
      need = [need];
      return need.every(val => array.includes(val));
    }


  }
}
</script>

<style scoped>

.coordinates-title {
  /*line-height: 22px;*/
  color: #000000;
  font-weight: 400;
  padding-right: 10px;
  cursor: move;
  position: relative;

  display: flex;
  /*overflow: auto;*/
}

.filler {
  background: #e1e1e1;
  padding: 2px 8px;
  position: absolute;
  top: -26px;
  left: -6px;
  font-size: 12px;
  border-radius: 1px;
}




/* 向下 */
.toolTip-bottom {
  position: absolute;
  width: 130px;
  height: 26px;
  border: 1px solid #000;
  border-radius: 3px;
  background-color: #000;
  color: #fbfbfb;
  top: -44px;
  left: 0;
}
.toolTip-bottom:before{
  content: '';
  display: block;
  position: absolute;
  bottom: -6px;
  left: 54px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #000;
}
.toolTip-bottom .toolTip-bottom-font {
  float: left; width: 49%;
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
}
.toolTip-bottom .toolTip-bottom-right {
  float: left; width: 1px;
  height: 10px; display: block;    margin-top: 8px;
  border-right: 1px solid #8f8f8f
}
</style>
